import {ProductIds as Product} from './../constants/ApplicationConstants';

module.exports = {
    getContent: function (productId, content) {
        switch (productId) {
            case Product.SUPER: return content.superannuation;
            case Product.PENSION: return content.pension;
            case Product.INVESTMENT: return content.investments;
        }

        return '';
    },
    adjustViewport: function () {
        var containerHeight = window.innerHeight
        let footer = document.getElementsByClassName('footer')[0];
        if (footer) {
            containerHeight -= footer.clientHeight;
        }

        return {
            minHeight: containerHeight + 'px'
        };
    }
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/FooterHelper.js